import { spacer4 } from '@spotify-internal/encore-foundation';
import { ButtonTertiary } from "../ButtonTertiary/index.mjs";
import styled from "../../styled-components.mjs";
export var CloseButton = styled(ButtonTertiary).withConfig({
  displayName: "CloseButton",
  componentId: "sc-i2fggp-0"
})(["position:absolute;top:", ";right:", ";[dir='rtl'] &{right:unset;left:", ";}"], spacer4, spacer4, spacer4);